import React, { FC, useState } from 'react';
import { MdFilterList as FilterIcon } from '@react-icons/all-files/md/MdFilterList';
import { Fab } from '@material-ui/core';
import FiltersDialog, { CustomersFilter } from './components/FiltersDialog';

interface Props {
  filters: Partial<Record<CustomersFilter, any>>;
  onFilterChange: (filters: Partial<Record<CustomersFilter, any>>) => void;
}

const FiltersButton: FC<Props> = ({ filters, onFilterChange }) => {
  const [filtersDialogOpened, setFiltersDialogOpened] = useState(false);

  return (
    <>
      <Fab color='primary' size='small' onClick={() => setFiltersDialogOpened(true)}>
        <FilterIcon />
      </Fab>

      <FiltersDialog
        filters={filters}
        open={filtersDialogOpened}
        onChange={onFilterChange}
        onClose={() => setFiltersDialogOpened(false)}
      />
    </>
  );
};

export default FiltersButton;
